import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FuseConfigService } from '../../../../../@fuse/services/config.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppRoutes } from '../../../../gt2/const/AppRoutes';
import { GT2FormPageAbstract } from '../../../../gt2/content/abstract/GT2FormPageAbstract';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { AppRoutesService } from '../../../../gt2/services/app-routes.service';
import { SupportContactService } from '../../../../gt2/content/contact/support-contact.service';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { Settings } from '../../../../gt2/settings/settings';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { JwtInterceptor } from '../../../../gt2/interceptors/JwtInterceptor';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'error-429',
  templateUrl: './error-429.component.html',
  styleUrls: ['./error-429.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class Error429Component
  extends GT2FormPageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  form: UntypedFormGroup | any;
  subject?: string;
  message?: string;
  last429URL?: string | null = null;

  /*
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    public location: Location,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private logger: NGXLogger,
    private formBuilder: UntypedFormBuilder,
    private titleService: Title,
    public appRoutesService: AppRoutesService,
    private supportContactService: SupportContactService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    if (JwtInterceptor.LAST_URL_429) {
      this.last429URL = JwtInterceptor.LAST_URL_429;
    }

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    //
    this.form = this.formBuilder.group({
      subject: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      message: [
        '',
        [Validators.minLength(Settings.inputMinChar), Validators.required],
      ],
    });

  }

  ngOnInit() {
    //this.titleService.setTitle(this.translate.instant("GENERIC.ERROR"));
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public onSendContactForm(): void {
    // this.logger.info("Error429Component.onSendContactForm()");
    if (this.last429URL) {
      this.message += ' - (last url: ' + this.last429URL + ')';
      //this.logger.info("&&&&&&& -> " + this.message);
    }

    const email: any = {
      subject: '(Error 429 page) ' + this.subject,
      message: this.message,
    };
    this.supportContactService.postEmailError429(email).subscribe({
      next: (response) => {
        // this.logger.info("Error429Component.onSendContactForm() -> SUCCESS: " + JSON.stringify(response));
        this.showConfirmationDialog();
      },
      error: (error) => {
        this.logger.error(
          'Error429Component.onSendContactForm() -> ERROR: ' +
            JSON.stringify(error),
        );
      },
    });
  }

  public override onPageBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const prefix = (localStorage.getItem('PREFIX') || '') + '/';
      this.router.navigateByUrl(prefix + AppRoutes.EVENTS);
    }
  }

  public onVisitGt2(): void {
    window.open('https://www.gestiontraiteur.com', '_blank');
  }

  public showConfirmationDialog(): void {
    this.subject = '';
    this.message = '';
    this.form.markAsUntouched();
    this.form.markAsPristine();

    this.dialogRef = this.dialog.open(GenericAlertComponent, {
      // width: '45%',
      disableClose: false,
    });
    this.dialogRef.componentInstance.alertTitle = '';
    this.dialogRef.componentInstance.alertMessage = this.translate.instant(
      'ERROR_429.SUCCESS_MESSAGE',
    );
    // this.dialogRef.componentInstance.showConfirmButton = false;

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.dialogRef = null;
      },
    });
  }
}
